import React from "react";
import ActivitiesPageGen from "./generated/ActivitiesPageGen";
import activitiesService from "../../../services/legacy/activitiesService";

const SHOW_IN_GRID = new Set(["activityid", "activitytype", "activitydatetime", "totaltime"]);
const SHOW_IN_FILTER = new Set(["activityid", "activitytype", "activitydatetime"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const ActivitiesPage = () => {
  const service = activitiesService;
  return <ActivitiesPageGen service={service} transformColumns={transformColumns} />;
};

export default ActivitiesPage;